"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreNumberBadge = _interopRequireDefault(require("@legacy-vfuk/core-number-badge"));

var Styled = _interopRequireWildcard(require("./styles/IconSenior.style"));

var _ruleSet = require("../../ruleSet");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconSenior = function IconSenior(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
      _ref$isResponsive = _ref.isResponsive,
      isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      state = _ref.state,
      numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M99.043 64.25h64.794M96 119.212c7.156-13.963 20.115-23.292 34.9-23.292 22.519 0 40.8 21.639 40.8 48.33m-17.78-73.263c0 12.522-10.311 22.682-23.02 22.682s-23.02-10.16-23.02-22.682S118.193 48.25 130.9 48.25h23.02v22.737ZM38.728 76.35l-5.009-1.288a16.133 16.133 0 0 1-2.347-.927c-6.121-2.988-8.625-10.3-5.593-16.33s10.453-8.498 16.574-5.51c.853.43 2.29 1.499 3.048 2.077",
    fill: "none",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.3 144.25c0-26.691 18.281-48.33 40.8-48.33s40.8 21.639 40.8 48.33M84.12 70.987c0 12.522-10.312 22.682-23.02 22.682s-23.02-10.16-23.02-22.682S48.39 48.25 61.1 48.25h23.02v22.737Z",
    fill: "none",
    vectorEffect: "non-scaling-stroke"
  })), numberBadge && /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })));
};

IconSenior.displayName = "IconSenior";
var _default = IconSenior;
exports["default"] = _default;
//# sourceMappingURL=IconSenior.js.map